<template>
  <div>
    <h1 class="page-title">My invitations</h1>
    <div v-if="invitationsReceived">
      <div>
        <h2 class="invitations-section-title">Invitations received:</h2>
        <div>
          <Invitation
            :key="i.id"
            v-for="i in invitationsReceived"
            :invitation="i"
          />
        </div>
      </div>
    </div>
    <div v-else>
      <div>No invitations yet.</div>
    </div>
  </div>
</template>

<script>
import Invitation from "@/components/atoms/Invitation";
import { mapState } from "vuex";

export default {
  components: { Invitation },
  computed: mapState({
    ownProfile: (state) => state.profiles.ownProfile,
    invitationsReceived(state) {
      return state.invitations?.invitations?.filter((e) => e.invitee.id === this.ownProfile.id)},
  }),
  mounted() {
    this.$store.commit("RESET_INVITATIONS");
    this.$store.dispatch("getInvitations");
  },
};
</script>
